// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__r4tP4","title":"style_title__KvETo","text":"style_text__BKsO5","navigate":"style_navigate__IKPCe"};